import React from 'react'
import Checkbox from '../../../../components/checkbox/basecheckbox/Checkbox'
import Label from '../../../../components/label/Label'
import { LABEL_WEIGHT } from '../../../../components/label/constants'
import TextInput from '../../../../components/input/textinput/TextInput'
import RichGrid from '../../../../components/richgrid/RichGrid'
import { ROW_SELECTION_OPTIONS } from '../../../../components/richgrid/constants'
import { componentKey, setRowsPerPage, setSkip, setTotalPayers, setPayersData, setFilterText } from './AssignPayersSlice'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { componentKey as ManageUserComponentKey, selectPayer, setSelectedGroupIDs} from '../../manageusers/ManageUserSlice'
import { assignGroupID, changeAssignPayers } from '../../manageusers/ManageUserSaga'
import Popup from '../../../../components/popup/Popup'
import { checkGroupIdChecked, getAssignedPayers, getGroupIDs, getPayersList, managePayersForMember } from './AssignPayersSaga'
import styles from './AssignPayers.styles'
import Button from '../../../../components/button/Button'
import { BUTTON_TYPE } from '../../../../components/button/constants'
import Loadable from '../../../../components/loadable/Loadable'
import { USER_LOADING_STATES, USER_MESSAGE_MAP } from '../../constant'

export default function AssignPayers() {

    const dispatch = useDispatch();
    const [searchString, setSearchString] = useState("");
    const [showGroupPopup, setShowGroupPopup] = useState(false);
    const [checked, setChecked] = useState([]);
    const [unChecked, setUnChecked] = useState([]);
    const [assignPayerDisabled, setAssignPayerDisabled] = useState(true);
    const {loadingState, rowsPerPage, skip, totalPayers, payersData, filterText, groupIDs, groupIdChecked } = useSelector((state) => state[componentKey])
    const {selectedMember, memberData, selectedGroupIDs, selectedPayers} = useSelector((state) => state[ManageUserComponentKey])

    const handleInputChange = (e) => {
        setSearchString(e.target.value);
    }
    const handleAssginAllPayers = (checked) => {
        setAssignPayerDisabled(false)
        dispatch(changeAssignPayers({MemberId: selectedMember.UserId, IsEnabled: checked}))
    }

    useEffect(()=>{
        const timeOutId = setTimeout(() => dispatch(setFilterText(searchString)), 500);
        return () => clearTimeout(timeOutId);
        
    }, [searchString])

    useEffect(()=>{
        dispatch(getPayersList({filterText, skip, rowsPerPage}))
    }, [skip, rowsPerPage, filterText])

    useEffect(()=>{
        if(selectedMember.UserId  && selectedMember.UserId !== 0) {
            dispatch(checkGroupIdChecked({memberId: selectedMember.UserId}))
        } 
    }, [])

    useEffect(() => {
        if(selectedMember?.UserId){
            dispatch(getAssignedPayers({ MemberId: selectedMember.UserId, PayerList: payersData }))
        }
    }, [payersData])

    const ASSING_PAYERS_COLUMNS = [
        {
            field: "payerName",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Payer Name</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{`${row?.FirstName ?? ""} ${row?.MiddleName ?? ""} ${row?.LastName ?? ""}`}</span>
        },
        {
            field: "tinNumber",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>TIN Number</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.IdNumber}</span>
        },
        {
            field: "groupID",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Group ID</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.GroupId}</span>
        },
    ]

    const handleAssginPayerByGroup = (checked) => {
        if(checked) {
            setShowGroupPopup(true)
            dispatch(getGroupIDs())
        }
        else {
            dispatch(assignGroupID({groupIDs: 'None', memberID: selectedMember.UserId, assign: false}))
        }
    }

    const handleSelectGroupID = (groupID, checked) => {
        if(checked){
            dispatch(setSelectedGroupIDs([...selectedGroupIDs, groupID]))
        } else {
            dispatch(setSelectedGroupIDs([...selectedGroupIDs.filter(ID => ID !== groupID)]))
        }
    }

    const isGroupIDSelected = (groupID) => {
        return selectedGroupIDs.find(ID => ID === groupID) ? true: false
    }
    const handleGroupSave = () => {
        dispatch(assignGroupID({groupIDs: selectedGroupIDs.join(","), memberID: selectedMember.UserId, assign: true}))
    }

    const handleHeaderSelection = (selectedData) => {
        if(selectedData.length === 0) {
            setUnChecked(payersData.map(payer => payer.PayerDetailId))
            setChecked([])
        } else {
            setChecked(payersData.map(payer => payer.PayerDetailId))
            setUnChecked([])
        }
        dispatch(selectPayer(selectedData))
    }

    const handleSingleSelection = (selectedData) => {
        setAssignPayerDisabled(false)
        if(selectedData.length > selectedPayers.length) {

            const selectedPayersList = selectedPayers.map(payer => payer.PayerDetailId)
            const newlySelected = selectedData.filter(payer => !selectedPayersList.includes(payer.PayerDetailId)).map(payer => payer.PayerDetailId)
            setChecked([...checked, ...newlySelected])

            const removeUnchecked = unChecked.filter(id => !newlySelected.includes(id))
            setUnChecked(removeUnchecked)

        } else if(selectedData.length < selectedPayers.length){

            const selectedDataList = selectedData.map(payer => payer.PayerDetailId)

            const newlySelected = selectedPayers.filter(payer => !selectedDataList.includes(payer.PayerDetailId)).map(payer => payer.PayerDetailId)
            setUnChecked([...unChecked,...newlySelected])
            const removeChecked = checked.filter(id => !newlySelected.includes(id))
            setChecked(removeChecked)

        }
        dispatch(selectPayer(selectedData))
    }
  
    useEffect(() => {
        setChecked(selectedPayers.map(payer => payer.PayerDetailId))
    }, [selectedPayers])

    const handleAssignPayers = () => {
        dispatch(managePayersForMember({
            MemberId: selectedMember.UserId,
            Checked : checked,
            UnChecked : unChecked
        }))
    }

    return (
    <div>
        <Loadable currentState={loadingState.state} loadingStates={[ USER_LOADING_STATES.ASSIGN_PAYER_LOADING, USER_LOADING_STATES.PAYERS_LIST_LOADING, USER_LOADING_STATES.PAYER_GROUP_FILTER_LOADING ]} messageMap={USER_MESSAGE_MAP} isNewLoadable={true}>
            <div style={styles.actionsRow}>
                <div style={styles.actionRowLeftColumn}>
                    <div style={styles.checkboxWithLabel}>
                        <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Assign existing Payers and all added in the future</Label>
                        <Checkbox checked={selectedMember.AssignAllPayers} onChangeCb={(e)=> handleAssginAllPayers(e.target.checked)}/>
                    </div>
                    <div style={styles.checkboxWithLabel}>
                        <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Assign Payers By GroupID</Label>
                        <Checkbox checked={groupIdChecked} onChangeCb={(e)=> handleAssginPayerByGroup(e.target.checked)}/>
                    </div>
                </div>
                <div style={styles.actionRowRightColumn}>
                    <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Search Filter: </Label>
                    <TextInput 
                        type={'text'}
                        placeHolder={"Search Here"} 
                        name={'search'} 
                        value={searchString} 
                        onChangeCb={(e) => handleInputChange(e)} 
                    />
                </div>
            </div>
            <RichGrid
                data={payersData}
                columns={ASSING_PAYERS_COLUMNS}
                selectable={true}
                extractRowKey={(row) => row.PayerDetailId}
                selectedRows={selectedPayers}
                onHeaderSelectionChangeCallBack={(selectedData) => handleHeaderSelection(selectedData)}
                onSelectionChangeCallBack={(selectedData) => handleSingleSelection(selectedData)}
                paginationProps={{
                    skip: skip,
                    take: rowsPerPage,
                    takeOptions: ROW_SELECTION_OPTIONS,
                    onChangeTakeCb: (newTake) => {
                        dispatch(setRowsPerPage(newTake));
                        dispatch(setSkip(0))
                    },
                    total: totalPayers,
                    onChange: (take, t) => {
                        dispatch(setRowsPerPage(take));
                        dispatch(setSkip(t))
                    },
                }}
            />
            <Button onClickCb={ handleAssignPayers } disabled={ assignPayerDisabled }>Assign Payers</Button>
        </Loadable>

        <Popup title={"Group IDs"} onCloseCb={()=>{setShowGroupPopup(false)}} isPopupOpen={showGroupPopup} customPopupSyles={styles.groupIDCustomPopupSyles} childrenStyles={styles.groupIDChildrenStyles}>
            <Loadable currentState={loadingState.state} loadingStates={[USER_LOADING_STATES.ASSIGN_PAYER_LOADING]} messageMap={USER_MESSAGE_MAP} isNewLoadable={true}>
                <div style={styles.groupIDList}>
                    {groupIDs.map((groupID => <div style={styles.groupIDListCheckbox}>
                        <Checkbox checked={isGroupIDSelected(groupID)} onChangeCb={(e)=> handleSelectGroupID(groupID, e.target.checked)}/>
                        <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>{groupID}</Label>
                    </div>))}
                </div>
                <div style={styles.groupPopupButtonRow}>
                    <Button type={BUTTON_TYPE.PRIMARY} style={styles.fullWidth} onClickCb={ handleGroupSave }>Save</Button>
                </div>
            </Loadable>
        </Popup>
    </div>
  )
}